export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Após concluir a negociação, ela será fechada. Os fundos internos serão transferidos para o usuário."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tem certeza de que deseja concluir a negociação?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sim, concluir"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não, manter ativa"])}
}